export enum DisparitySubType {
  WOBBLERS = -1,
  TARGET_VERSUS_COMPARATORS = -2,
  ENHANCEMENT = -3,
}
